import { render, staticRenderFns } from "./HexaPieChart.vue?vue&type=template&id=c0980ea6&"
import script from "./HexaPieChart.vue?vue&type=script&lang=js&"
export * from "./HexaPieChart.vue?vue&type=script&lang=js&"
import style0 from "./HexaPieChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HexaPieChart.vue"
export default component.exports